module.exports = __webpack_public_path__ + "img/pattern-randomized.c083f1c6.svg";